import { environment as custom } from "../themes/BigMountainLodge/environments/environment"
export const environment = {
  ...custom,
  template: custom.template,
  production: true,
  itineraryBuilderSDK: {
    base_url: 'https://itinerarybuilderapi.trueomni.com'
  },
  scavengerHunt: {
    base_url: 'https://scavengerhuntapi.trueomni.com'
  },
  reviewsAPI: {
    base_url: 'https://reviewsapi.trueomni.com'
  },
  googleMaps0: 'AIzaSyAb0SnmmZsewjJYWVDY5U3D8-oo1zKh-Jg',
  googleMaps: 'AIzaSyBgCFgTb5Fmfda3MAkoXH3BGHJ-vew_9kU',
  cookies: {
    defaultExpiration: 182,
    authCookieName: 'auth'
  },
  pwaAPI:{
    base_url: "https://webservice.trueomni.com/json.aspx", 
    new_base_url: "https://trueomni-pwa-api.azurewebsites.net/",
    notifications_url: "https://trueomni-notifications-qa.azurewebsites.net"
  },
  paypal: {
    enabled: true,
    currency: 'USD',
    clientId: 'sb',
    category: 'DIGITAL_GOODS'
  },
  cloudbedsApi: {
    url: 'https://hos-api-qa.trueomni.com/api'
    //url: 'https://localhost:44315/api'
  },
  truePayApi: {
    //url: 'https://truepay.azurewebsites.net/api'
    url: 'https://truepay-qa.azurewebsites.net/api'
  },
  tokenUniversal: {
    token: "DWuAh7qPqHqyp8la7Os4568OuHLu6dbpyvo11ZtsIfPvAnQgZOEPQk9Ssqdlb42VqVI"
  },
  tavus: {
    replica_id:"rf4703150052",
    persona_id:"p18302576d65",
    callback_url:"https://tavusapi.com/v2/",
    api_key: '73c0b1d9ebd141db929d783d53873da6',
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
